import analytics from '@/utils/analytics/analyticsInstance';
import { Box, Link, styled, Typography, useTheme } from '@mui/material';

const Container = styled(Box)(() => ({
  textAlign: 'center',
}));

export default function Agreement() {
  const theme = useTheme();

  return (
    <Container>
      <Typography
        variant="caption"
        color={theme.palette.text.disabled}
        fontWeight={400}
        textAlign="center"
        lineHeight="16px"
      >
        By proceeding to use Findies, you agree to our <br />
        <Link
          href="https://dealpump.notion.site/Terms-of-use-1886db3beb86805fb50ef8b09d3c0363?pvs=4"
          target="_blank"
          color="inherit"
          underline="none"
          fontWeight={700}
          onClick={() => {
            analytics.track('webOnboardingLegalDocsClicked', {
              legal_doc_name: 'Terms and Conditions',
              legal_doc_url:
                'https://dealpump.notion.site/Terms-of-use-1886db3beb86805fb50ef8b09d3c0363?pvs=4',
            });
          }}
        >
          Terms and Conditions
        </Link>{' '}
        and{' '}
        <Link
          href="https://dealpump.notion.site/Privacy-policy-1886db3beb86807fac5bf6b40b9f5a5a?pvs=4"
          target="_blank"
          color="inherit"
          underline="none"
          fontWeight={700}
          onClick={() => {
            analytics.track('webOnboardingLegalDocsClicked', {
              legal_doc_name: 'Privacy Policy',
              legal_doc_url:
                'https://dealpump.notion.site/Privacy-policy-1886db3beb86807fac5bf6b40b9f5a5a?pvs=4',
            });
          }}
        >
          Privacy Policy
        </Link>
      </Typography>
    </Container>
  );
}
